import { Badge } from "antd";
import cn from "classnames";
import { forwardRef, ReactNode } from "react";

import styles from "./AppShell.module.scss";

type Props = {
  icon: ReactNode;
  label: string;
  count?: number;
  onClick?: () => void;
  className?: string;
  testId?: string;
};

/** Round icon action of the app bars (chat, notifications…). `label` is its accessible name. */
export const ShellIconButton = forwardRef<HTMLButtonElement, Props>(
  ({ icon, label, count, onClick, className, testId }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={cn(styles.iconButton, className)}
      onClick={onClick}
      data-testid={testId}
    >
      <Badge count={count} overflowCount={99} size="small" offset={[2, -2]}>
        <span className={styles.iconButtonGlyph}>{icon}</span>
      </Badge>
    </button>
  ),
);
ShellIconButton.displayName = "ShellIconButton";
